import { render } from "./WeekTrainerCycle.vue?vue&type=template&id=4e6085ae"
import script from "./WeekTrainerCycle.vue?vue&type=script&lang=js"
export * from "./WeekTrainerCycle.vue?vue&type=script&lang=js"

import "./WeekTrainerCycle.vue?vue&type=style&index=0&id=4e6085ae&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__